import { Logo } from "./Logo";
import { CTA_URL } from "../constants/site";

const products = ["SalonUP", "MOM", "CONNECT", "MOM Tabuada"];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-charcoal/[0.08] bg-white">
    <div className="mx-auto grid max-w-6xl gap-12 px-6 py-16 md:grid-cols-[1.4fr_1fr_1fr] md:py-20">
      <div className="space-y-5">
        <Logo />
        <p className="max-w-xs text-sm leading-relaxed text-charcoal/55">
          Tecnologia para salões modernos. O que acontece no salão vira informação. A informação vira gestão.
        </p>
      </div>

      <nav aria-label="Produtos" className="space-y-4">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-charcoal/40">Produtos</p>
        <ul className="space-y-2.5">
          {products.map((p) => (
            <li key={p} className="text-sm text-charcoal/65">
              {p}
            </li>
          ))}
        </ul>
      </nav>

      <nav aria-label="Contato" className="space-y-4">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-charcoal/40">Contato</p>
        <a
          href={CTA_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-cta-link"
          className="inline-flex text-sm font-medium text-salon transition-colors hover:text-salon-deep"
        >
          Conhecer a SalonUP →
        </a>
      </nav>
    </div>

    <div className="border-t border-charcoal/[0.06]">
      <div className="mx-auto flex max-w-6xl flex-col gap-2 px-6 py-6 text-xs text-charcoal/40 md:flex-row md:items-center md:justify-between">
        <span>© {new Date().getFullYear()} SalonUP. Todos os direitos reservados.</span>
        <span>Termos e privacidade em breve.</span>
      </div>
    </div>
  </footer>
);
